import PropTypes from 'prop-types'
import { RdtTimesWarningLevels } from '../../models/rdt/rdt-times-warning-levels-enum'

export const rdtWarningLevelPropType = PropTypes.oneOf(Object.values(RdtTimesWarningLevels))
